export default "__VITE_ASSET__C1Z_cXRX__"